module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNi4xOSAyOC4wNCI+PHRpdGxlPmFycm93LXJpZ2h0LXdoaXRlNDwvdGl0bGU+PHBhdGggZD0iTTEwLjc5LDE0TDAsMjUuMjIsMi43LDI4LDE2LjE5LDE0LDIuNywwLDAsMi43OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC4wMikiIGZpbGw9IiNmZmYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-right-white4.svg
// module id = zjti
// module chunks = 0